import React, { useEffect, useState } from "react";
import axios from "axios";
import { TabMenu } from "primereact/tabmenu";
import { ProgressSpinner } from "primereact/progressspinner";
import Table from "./DelDatasets";
import { InputText } from "primereact/inputtext";

import { AsmsTable } from "./AsmsDatasets";

const TopBar = () => (
  <div className="flex flex-row mx-auto w-full justify-center">
    <h1 className="text-gray-800 font-bold text-2xl md:text-3xl">Datasets</h1>
  </div>
);

const Datasets = () => {
  const [datasets, setDatasets] = useState([]);
  const [dict, setDict] = useState([]);
  const [isloading, setLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");

  const items = [
    { label: "DEL-Datasets", icon: "pi pi-fw pi-database" },
    { label: "E-ASMS Datasets", icon: "pi pi-fw pi-database" },
  ];

  useEffect(() => {
    const getDatasets = async () => {
      try {
        setLoading(true);
        const [datasetRes, dictRes] = await Promise.all([
          axios.get("/api/data/dataset"),
          axios.get("/api/data/dictionary"),
        ]);
        setDatasets(datasetRes.data);
        setDict(dictRes.data);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching data: ", error);
      } finally {
        setLoading(false);
      }
    };
    getDatasets();
  }, []);

  if (isloading) {
    return (
      <div className="h-screen flex justify-content-center items-center">
        <ProgressSpinner
          style={{ width: "250px", height: "250px" }}
          strokeWidth="6"
        />
      </div>
    );
  }

  return (
    <div className="container min-h-screen mx-auto px-4 pt-40 md:pt-20 py-20 md:px-20">
      <div
        className="flex flex-row text-orange-700 text-l font-bold px-4 pb-2 pt-12"
        role="alert"
      >
        <svg
          className="fill-current w-12 h-6 mr-2 self-start md:mt-1.5"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          style={{ fill: "#ff0000" }}
        >
          <path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z" />
        </svg>
        <p className="flex-grow">
          Attention all DEL-ML enthusiasts! Our datasets are currently being
          benchmarked to ensure you get the most accurate and valuable data
          possible. We're just as excited as you are and promise it will be
          worth the wait. Stay connected for the big reveal later this year!
        </p>
      </div>
      <TopBar />
      {/* Search Bar */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between w-full md:mb-2">
        {/* Left - Search Box */}
        <div className="flex mb-4 md:mb-0 items-center gap-3 ml-2">
          <i className="pi pi-search text-[#06002e] text-2xl" />
          <span className="p-float-label border border-[#e53201]  rounded-lg">
            <InputText
              id="search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="custom-input text-black rounded-xl px-2 py-2 transition duration-200 w-64"
            />
            <label
              htmlFor="search"
              className="font-medium !transition-all !duration-200"
            >
              Search
            </label>
          </span>
        </div>

        {/* Center - TabMenu */}
        <div className="flex-1 flex mr-48 justify-center w-full">
          <TabMenu
            model={items}
            activeIndex={selectedTab}
            onTabChange={(e) => setSelectedTab(e.index)}
            className="custom-tabmenu"
            style={{ overflowX: "visible" }}
          />
        </div>
      </div>
      {selectedTab === 0 && (
        <Table
          datasets={datasets}
          dict={dict}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
        />
      )}
      {selectedTab === 1 && (
        <AsmsTable
          dict={dict}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
        />
      )}
    </div>
  );
};

export default Datasets;
